import { render, staticRenderFns } from "./UserSearchAndSelect.vue?vue&type=template&id=3f90cb02&scoped=true&"
import script from "./UserSearchAndSelect.vue?vue&type=script&lang=js&"
export * from "./UserSearchAndSelect.vue?vue&type=script&lang=js&"
import style0 from "./UserSearchAndSelect.vue?vue&type=style&index=0&id=3f90cb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90cb02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
